import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type FitDetailsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function FitDetailsSection({ item }: FitDetailsSectionProps) {
  return (
    <Section
      icon="scale"
      title="Fit Details"
      color="indigo"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="fit-details-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <Stack direction="row" className="gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Length"
            value={item?.length}
            id="length"
          />
          <ReadOnlyField
            className="flex-1"
            label="Inseam"
            value={item?.inseam}
            id="inseam"
          />
          <ReadOnlyField
            className="flex-1"
            label="Stretch"
            value={item?.stretch}
            id="stretch"
          />
        </Stack>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Neckline"
            value={item?.neckline}
            id="neckline"
          />
          <ReadOnlyField
            className="flex-1"
            label="Sleeve Length"
            value={item?.sleeve_length}
            id="sleeve-length"
          />
          <ReadOnlyField
            className="flex-1"
            label="Top Length"
            value={item?.top_length}
            id="top-length"
          />
        </div>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Body Fit (Top)"
            value={item?.body_fit_top}
            id="body-fit-top"
          />
          <ReadOnlyField
            className="flex-1"
            label="Body Fit (Bottom)"
            value={item?.body_fit_bottom}
            id="body-fit-bottom"
          />
          <ReadOnlyField
            className="flex-1"
            label="Bottom Length"
            value={item?.bottom_length}
            id="bottom-length"
          />
        </div>
      </Stack>
    </Section>
  );
}

export default FitDetailsSection;
